function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
export const usePdfPassword = () => {
  const [password, setPassword] = React.useState({
    requesting: false,
    incorrect: false
  });
  const passIntroduced = React.useRef(false);
  const passCallback = React.useRef(null);
  const onPassword = React.useCallback(callback => {
    if (!passIntroduced.current) {
      passIntroduced.current = true;
      passCallback.current = callback;
      setPassword(pass => _objectSpread(_objectSpread({}, pass), {}, {
        requesting: true
      }));
    } else {
      setPassword(_objectSpread(_objectSpread({}, password), {}, {
        incorrect: true,
        requesting: false
      }));
    }
  }, []);
  const unlock = React.useCallback(pass => {
    setPassword(pass => _objectSpread(_objectSpread({}, pass), {}, {
      requesting: false
    }));
    passCallback.current && passCallback.current(pass);
  }, []);
  return [password, {
    onPassword,
    unlock
  }];
};